class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
      // document.querySelector('body').classList.remove('open-filter','open-sort');
      typeof infinitescroll == 'object' && typeof infinitescroll?.scolljs == 'function' && infinitescroll?.scolljs()
    }, 500);
    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
    // const applyfilter = this.querySelector('.apply-filter');
    // if (applyfilter) applyfilter.addEventListener('click', this.debouncedOnSubmit.bind(this));    
    const filterbtn = this.querySelector('.filter-button');
    if(filterbtn) filterbtn.addEventListener('click',function(e){
      e.preventDefault();
      let right = window.innerWidth - document.body.clientWidth;
      if(document.querySelector('body').classList.contains('sticky-filter')){
        document.querySelector('body').style.paddingRight = right+'px';
        document.querySelector('main').style.width = 'calc(100% + '+right+'px)';
      }else{
        document.querySelector('body').style.paddingRight = '';
        document.querySelector('main').style.width = '';
      }
      document.querySelector('body').classList.toggle('open-filter');
      document.querySelector('body').classList.remove('open-sort','open-drawer','open-menu','open-search','open-subcoll');
      // if(!document.querySelector('body').classList.contains("open-filter")){
      //   document.querySelector('body').classList.remove('filter-sticky');
      //   // document.body.scrollTop = document.documentElement.scrollTop = 0;
      //   document.querySelector('.coll-filter-wrapper').style.height = '';
      // }else{
      //   setTimeout(() => {
      //     let topPosition = document.querySelector('.collection-filter').getBoundingClientRect().top + document.querySelector('.filter-top-wrapper').offsetHeight;
      //     document.querySelector('.coll-filter-wrapper').style.height = (window.innerHeight - topPosition) + 'px';
      //   }, 300);
      // }
    });
    document.querySelectorAll('.close-filter,.view-filter-btn').forEach(function(closeFilter){
      closeFilter.addEventListener('click',function(e){
        e.preventDefault();
        document.querySelector('body').classList.remove('open-filter');
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      });
    });
  }
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }
  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
      FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }
  static renderSectionFromFetch(url, event) {
    fetch(url)
    .then(response => response.text())
    .then((responseText) => {
      const html = responseText;
      FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      //FacetFiltersForm.renderActiveFilter(html);
      typeof infinitescroll == 'object' && typeof infinitescroll?.scolljs == 'function' && infinitescroll?.scolljs()
      if(typeof quickAddButton == 'function'){
        quickAddButton();
        filter_acco();
        quick_buy_btn();
        if(localStorage.getItem("collection_grid") == null){
          localStorage.setItem("collection_grid", document.querySelector(".coll-view a.active").getAttribute('data-view'));
        }else{
          document.querySelector(".collection-grid").setAttribute('data-desk',localStorage.getItem("collection_grid"));
          if(document.querySelector(".coll-view a.active").getAttribute('data-view') != localStorage.getItem("collection_grid")){
            document.querySelector(".coll-view a.active").classList.remove('active')
            let deskGrids = document.querySelectorAll(".coll-view a");
            deskGrids.forEach((deskGrid) => {
              let desk_val = deskGrid.getAttribute('data-view')
              if(parseInt(desk_val) == parseInt(localStorage.getItem("collection_grid"))){
                deskGrid.classList.add('active')
              }
            });
          }
        }
        load_more();
      }
    });

    function quick_buy_btn(){
      quickAddButton();
      document.querySelectorAll('.quick_view_button').forEach((quickBtn) => {
        quickBtn.addEventListener('click',function(e){
          e.preventDefault();
          e.stopImmediatePropagation();
          let url = quickBtn.getAttribute('data-url');
          let modal = quickBtn.getAttribute('data-modal');
          fetch(url)
          .then((response) => response.text())
          .then((response) => {
            const html = new DOMParser().parseFromString(response, 'text/html');
            const source = html.getElementById('section-quick-buy');
            document.body.classList.add('open-quick-buy');
            document.getElementById(modal).getElementsByClassName('quick-buy-popup')[0].innerHTML = source.innerHTML;
            addToCart();
          })
          .catch((e) => {console.error(e);})
        })
      })
      resize_promo();
    }
  }
  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    //FacetFiltersForm.renderActiveFilter(html);
    if(typeof quickAddButton == 'function'){
      quickAddButton();
      filter_acco();
      load_more();
    }
  }
  static renderProductGridContainer(html) {
    document.getElementById('collection-grid').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('collection-grid').innerHTML;
    let count = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid').getAttribute('data-count');
    document.querySelectorAll('.filter-total-count').forEach(total_count => {
      total_count.textContent = count;
    });
  }
  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements = parsedHTML.querySelectorAll('.facet-list');
    const filterSections = document.querySelectorAll('.filter-wrap .filter-index');
    let all_filter_count = 0;
    filterSections.forEach(section => {
      const selectedFilters = section.querySelectorAll('input[type="checkbox"]:checked:not(.filter-available)');
      const count = selectedFilters.length;
      section.querySelectorAll('input[type="checkbox"]:checked:not(.filter-available)').forEach((index,list) => {
        all_filter_count++;
      });
      const filterCountElement = section.querySelector('.filter-count');
      if (filterCountElement) {
        filterCountElement.textContent = count > 0 ? `(${count})` : '';
      }
    });
    if(document.querySelector('.range-wrap.active-price-filter')){
      all_filter_count++;
    }
    if(all_filter_count > 0){
      document.querySelector('.all-filter-count').textContent = '('+all_filter_count+')';
      document.querySelector('.filter-clear-all .all-filter-count').classList.add('d-none');
      document.querySelector('.filter-clear-all .clear-all').classList.remove('d-none');
      document.querySelector('.filter-clear-all .clear-all').classList.add('d-block');
      document.querySelector('.view-filter-btn .close-filter').classList.add('d-none');
      document.querySelector('.view-filter-btn .filter-count-btn').classList.remove('d-none');
      document.querySelector('.view-filter-btn .filter-count-btn').classList.add('d-block');
      if (window.innerWidth <= 768) {
        document.querySelector('.coll-filter-btm .close-filter.button.button-black.button-full').classList.remove('d-block');
        document.querySelector('.view-filter-btn').classList.remove('d-none');
      }
    }else{
      document.querySelector('.all-filter-count').textContent = '';
      document.querySelector('.filter-clear-all .all-filter-count').classList.remove('d-none');
      document.querySelector('.filter-clear-all .clear-all').classList.add('d-none');
      document.querySelector('.filter-clear-all .clear-all').classList.remove('d-block');
      document.querySelector('.view-filter-btn .close-filter').classList.remove('d-none');
      document.querySelector('.view-filter-btn .filter-count-btn').classList.add('d-none');
      document.querySelector('.view-filter-btn .filter-count-btn').classList.remove('d-block');
      if (window.innerWidth <= 768) {
        document.querySelector('.coll-filter-btm .close-filter.button.button-black.button-full').classList.add('d-block');
        document.querySelector('.view-filter-btn').classList.add('d-none');
      }
    }
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.facet-list') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    facetsToRender.forEach((element) => {
      if(document.querySelector(`.filter-index[data-index="${element.dataset.index}"]`)) document.querySelector(`.filter-index[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });
  }
  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }
  static getSections(){
    return [
      {
        section: document.getElementById('collection-grid').dataset.id,
      }
    ]
  }
  onSubmitHandler(event){
    const filterCheck=(params)=>{
      let available = params.match(/filter/g)
      if(available === null){
        available = 0
      }else{
        available = available.length
      }
      return available
    }
    event.preventDefault();
    let formData = new FormData(event.target.closest('form'));
    let searchParams = new URLSearchParams(formData).toString();
    const result = filterCheck(searchParams);
    if(!(searchParams.includes("availability"))){
      if(result > 0){
        searchParams = searchParams + "&filter.v.availability=1";
      }
    }else if(result < 2){
      searchParams = searchParams.replace("filter.v.availability=1&", "");
    }
    FacetFiltersForm.renderPage(searchParams, event);
    if(!document.querySelector('body').classList.contains('open-filter')) document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
function filterprice(){
  var inputLeft = document.querySelector(".price-left");
  var inputRight = document.querySelector(".price-right");
  var amountLeft = document.querySelector(".amount-left .amount-percentage");
  var amountRight = document.querySelector(".amount-right .amount-percentage");
  var thumbLeft = document.querySelector(".price-slider > .thumb.left");
  var thumbRight = document.querySelector(".price-slider > .thumb.right");
  var range = document.querySelector(".price-slider > .range");
  var rangeWrap = document.querySelector(".range-wrap");
  let count = parseInt(document.querySelector('.all-filter-count').textContent.split('')[1]);
  function updateActiveState(){
    var min = parseInt(inputLeft.min);
    var max = parseInt(inputRight.max);
    var leftValue = parseInt(inputLeft.value);
    var rightValue = parseInt(inputRight.value);
    let get_val = false;
    if(leftValue > min || rightValue < max){
      rangeWrap.classList.add("active-price-filter");
    }else{
      rangeWrap.classList.remove("active-price-filter");
    }
  }
  function setLeftValue(){
    var _this = inputLeft,
        min = parseInt(_this.min),
        max = parseInt(_this.max);
    _this.value = Math.min(parseInt(_this.value), parseInt(inputRight.value) - 1);
    var percent = ((_this.value - min) / (max - min)) * 100;
    thumbLeft.style.left = percent + "%";
    amountLeft.innerHTML = _this.value;
    range.style.left = percent + "%";
    updateActiveState();
  }
  setLeftValue();
  function setRightValue() {
    var _this = inputRight,
        min = parseInt(_this.min),
        max = parseInt(_this.max);
    _this.value = Math.max(parseInt(_this.value), parseInt(inputLeft.value) + 1);
    var percent = ((_this.value - min) / (max - min)) * 100;
    thumbRight.style.right = (100 - percent) + "%";
    amountRight.innerHTML = _this.value;
    range.style.right = (100 - percent) + "%";
    _this.style.zIndex  = 3;    
    updateActiveState();
  }
  setRightValue();
  inputLeft.addEventListener("input", setLeftValue);
  inputRight.addEventListener("input", setRightValue);
}
if(document.querySelector('.range-wrap')){
  filterprice();
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fnBrowserDetect(){
  let userAgent = navigator.userAgent;
  let browserName;
  if(userAgent.match(/chrome|chromium|crios/i)){
    browserName = "chrome";
  }else if(userAgent.match(/firefox|fxios/i)){
    browserName = "firefox";
  }  else if(userAgent.match(/safari/i)){
    browserName = "safari";
  }else if(userAgent.match(/opr\//i)){
    browserName = "opera";
  } else if(userAgent.match(/edg/i)){
    browserName = "edge";
  }else{
    browserName="no-browser";
  }
  document.getElementById('MainContent').classList.add(browserName);
}
fnBrowserDetect();
function filter_acco(){
  if(document.querySelectorAll('.filter-title')) document.querySelectorAll('.filter-title').forEach((filterAcco) => {
    filterAcco.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      let allFacetLists = document.querySelectorAll('.facet-list');
      let currentFacetList = filterAcco.closest('.facet-list');
      allFacetLists.forEach((facetList) => {
        if(facetList !== currentFacetList){
          facetList.classList.remove("active");
          let content = facetList.querySelector(".filter-inr-wrap");
          if(content) content.style.height = '0px';
        }
      });
      if(currentFacetList.classList.contains("active")){
        currentFacetList.classList.remove("active");
        let content = currentFacetList.querySelector(".filter-inr-wrap");
        if(content) content.style.height = '0px';
      }else{
        currentFacetList.classList.add("active");
        let content = currentFacetList.querySelector(".filter-inr-wrap");
        if(content){
          if(content.querySelector("ul")){
            content.style.height = content.querySelector("ul").scrollHeight + "px";
          }else if(content.querySelector(".range-wrap")){
            content.style.height = content.querySelector(".range-wrap").scrollHeight + "px";
          }
        }
      }
    });
  });
  if(document.querySelectorAll('.filter-read-less')) document.querySelectorAll('.filter-read-less').forEach((filter_read_less) => {
    filter_read_less.addEventListener('click', function(e){
      e.preventDefault();
      filter_read_less.closest('.filter-inr-wrap').classList.toggle('show-all-filter');
      filter_read_less.closest('.filter-inr-wrap').style.height = filter_read_less.closest('.filter-inr-wrap ul').scrollHeight+'px';
    });
  });
}
filter_acco();